export const NAMESPACE_PREFIX = 'jira-list-view-statistics';
export const DAY_IN_MS = 24 * 60 * 60 * 1000;
